
import Header from '@/components/header.vue';
import { defineComponent, reactive, ref } from 'vue';
import ActiveList from '@/components/ActiveList.vue';
import { List, PullRefresh, Toast } from 'vant';
import { useRouter, useRoute } from 'vue-router';
import getList from '@/http/castList';

export default defineComponent({
  components: {
    ActiveList,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    Header,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    });
    const pages = reactive({
      pageNo: 0,
      pageSize: 6,
      type: 1,
    });
    // 跳转
    const onJump = (id: string, pro: string, status: string) => {
      router.push({
        path: '/caseForm',
        query: { projectId: pro, type: 2, status },
      });
    };
    const onLoad = () => {
      console.log('11');
      state.loading = true;
      state.finished = false;
      pages.pageNo += 1;
      getList(pages).then((res: any) => {
        const { total } = res.result;
        const data: [] = res.result.records;
        state.refreshing = false;
        state.list.push(...data);
        state.loading = false;
        if (state.list.length === total) {
          state.finished = true;
        }
      });
    };
    const onRefresh = () => {
      state.list = [];
      pages.pageNo = 0;
      onLoad();
    };
    return {
      state,
      onLoad,
      onJump,
      onRefresh,
    };
  },
});
